SNI.Application.addModule('kd-player', (context) => {

  let debug = context.getService('logger').create('module.video');
  const kdPlayer = context.getService('kd-player');
  const config = context.getConfig();
  const { webPlayer } = config;
  const webPlayerId = webPlayer.playerId;
  const el = context.getElement();
  const getContainer = () => el.querySelector('[data-player-id]');

  // Track which videos have been started and ended by videoIndex and braze events
  // braze:video-start and braze:video-end
  const videoPlayCount = {};


  const messageHandlers = {
    'kdp-library-loaded': ({ playerId, videoIndex = 0 }) => {
      if (webPlayer && (playerId === webPlayerId)) {
        const playType = 'manual';
        context.broadcast('kdp-library-play-video', { playerId, videoIndex, playType });
      }
    },
    'kdp-library-play-video': ({ playerId, videoIndex = 0, playType = 'manual' }) => {
      if (webPlayer && (playerId === webPlayerId)) {
        kdPlayer.loadNewKDPVideo({playerId, config, videoIndex, playType});
        dispatchBrazeEvent('braze:video-start', videoIndex);
      }
    },
    'kdp-library-end-card-click': ({ playerId, currentIndex, playType = 'manual' }) => {
      const { channels } = webPlayer;
      const currentIndexNum = parseInt(currentIndex);
      if (webPlayer && (playerId === webPlayerId)) {
        const eventString = 'braze:video-end';
        const onlyOneVideo = channels[0] && channels[0].total && channels[0].total === 1;
        if (onlyOneVideo) {
          // If there's only a single video, when it ends we just need to show the replay button
          kdPlayer.toggleReplayVideoScreen({playerId, showReplayVideoScreen: true});
          dispatchBrazeEvent(eventString, currentIndexNum);
          return;
        } else {
          // If there's an endcard with a new video or a playlist, we need to destroy this video
          // to be ready for the next one
          
          const endIndex = channels[0] && channels[0].end;
          let newIndex = currentIndexNum + 1;
          if (newIndex > endIndex) {
            newIndex = 0;
          }
          dispatchBrazeEvent(eventString, currentIndexNum);
          kdPlayer.prepareForNewVideo({ playerId, videoIndex: newIndex, playType });
        }
      }
    },
    'ad-break-completed': () => {},
    'invoke-inline-video.kdp': ({ playerId, $videoButtonPoster } ) => {
      kdPlayer.posterClick({playerId, $videoButtonPoster });
    },
    'kdp-remove-module-player': ({ playerId }) => {
      if (playerId === webPlayerId) removePlayer();
    },
    'display-ad-msg': displayAdsText
  }; //end messageHandlers

  // Advertisement copy
  function displayAdsText(state) {}

  function removeAllChildNodes(parent) {
    while (parent.firstChild) {
      parent.removeChild(parent.firstChild);
    }
  }

  function dispatchBrazeEvent(event, videoIndex) {
    if (!videoPlayCount[videoIndex]) videoPlayCount[videoIndex] = {};
    if (
      webPlayer.channels && 
      webPlayer.channels.length && 
      webPlayer.channels[0].videos &&
      webPlayer.channels[0].videos.length &&
      !videoPlayCount[videoIndex][event]
    ) {
      const currentVideo = webPlayer.channels[0].videos[videoIndex];

      if (
        currentVideo && 
        currentVideo.displayMetadata && 
        currentVideo.displayMetadata.showEpisodeTitle &&
        currentVideo.tags
      ) {
        context.broadcast(event, {
          title: currentVideo.displayMetadata.showEpisodeTitle,
          contentTags: currentVideo.tags.map(tag => tag.title).join(', ')
        });
  
        videoPlayCount[videoIndex][event] = 1;
      }
    }
  }

  function removePlayer() {
    let video = getContainer();
    removeAllChildNodes(video);
  }

  return {
    messages: Object.keys(messageHandlers),
    onmessage(msg, data) {
      messageHandlers[msg](data);
    },

    init() {
      let playerId;
      if (webPlayer) {
        playerId = webPlayerId;
        debug.log('Ads Config in use');
        kdPlayer.bindVideoElements({ playerId });
      }
    }
  };

});
